import { BaseFetch } from "../main-model"
export default class ReportAwardModel extends BaseFetch {
    getReportAwardBy = (data) =>
    this.authFetch({
      url: "report-award/getReportAwardBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getReportAwardBySubmit = (data) =>
    this.authFetch({
      url: "report-award/getReportAwardBySubmit",
      method: "POST",
      body: JSON.stringify(data),
    })
    getReportEventBySubmit = (data) =>
    this.authFetch({
      url: "report-award/getReportEventBySubmit",
      method: "POST",
      body: JSON.stringify(data),
    })
    getReportAwardYear = (data) =>
    this.authFetch({
      url: "report-award/getReportAwardYear",
      method: "POST",
      body: JSON.stringify(data),
    })
    getReportEventBy = (data) =>
    this.authFetch({
      url: "report-award/getReportEventBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getReportAwardBureauBy = (data) =>
    this.authFetch({
      url: "report-award/getReportAwardBureauBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getReportAwardBureauAndSchoolBy = (data) =>
    this.authFetch({
      url: "report-award/getReportAwardBureauAndSchoolBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    
}
